export interface RgbColor {
  r: number;
  g: number;
  b: number;
}

function normalizeHex(hex: string): string {
  return hex.trim().replace(/^#/, '');
}

export function hexToRgb(hex: string): RgbColor | null {
  const normalized = normalizeHex(hex);

  if (normalized.length === 3 || normalized.length === 4) {
    const r = normalized[0];
    const g = normalized[1];
    const b = normalized[2];
    return {
      r: parseInt(r + r, 16),
      g: parseInt(g + g, 16),
      b: parseInt(b + b, 16)
    };
  }

  if (normalized.length === 6 || normalized.length === 8) {
    return {
      r: parseInt(normalized.slice(0, 2), 16),
      g: parseInt(normalized.slice(2, 4), 16),
      b: parseInt(normalized.slice(4, 6), 16)
    };
  }

  return null;
}

interface GlowOptions {
  blur?: number;
  alpha?: number;
  saturation?: number;
}

export function selectionGlowFilter(hex: string, options?: GlowOptions): string | undefined {
  const { blur = 18, alpha = 0.55, saturation = 1.25 } = options ?? {};
  const rgb = hexToRgb(hex);

  if (!rgb) {
    return undefined;
  }

  const dropShadow = `drop-shadow(0 0 ${blur}px rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha}))`;

  if (Math.abs(saturation - 1) < 0.001) {
    return dropShadow;
  }

  return `saturate(${saturation}) ${dropShadow}`;
}
